import React, { useEffect, useState } from "react";
import "./Website.css";
import Lottie from "lottie-react";
import techAnimation from "../assests/TechAnimation.json";
export default function Website() {

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div id="Website" className="Website wf-section">
      <div className="techHero1">
              <div className="topCurve"></div>
              <div className="techCardFull">
                <div className={`logo_curve1 ${isScrolled ? "logo_curve1_scrolled" : ""}`}></div>
                <div className={`logo_curve2 ${isScrolled ? "logo_curve2_scrolled" : ""}`}></div>
                <div className={`menu-icon-curve1 ${isScrolled ? "menu-icon-curve1_scrolled" : ""}`}></div>
                <div className={`menu-icon-curve2 ${isScrolled ? "menu-icon-curve2_scrolled" : ""}`}></div>
                <div className="menu-icon-curve1_MV"></div>
                <div className="menu-icon-curve2_MV"></div>
                <div className="logo_curve1_Mo"></div>
                <div className="logo_curve2_Mo"></div>
                <div className="techContent1_M">
                  <h1 className="tech-title1_M">WEB<br/><span>DEVELOPMENT</span></h1>
                </div>
                <div className="tech-animation2">
                  <Lottie animationData={techAnimation} loop={true} speed={0.1} />
                </div>
              </div>
            </div>  
      <div className="softwareSection">
      <h1 className="mainHeading1">
    KNOW WEB DEVELOPMENT INSIDE OUT
  </h1>
  <p className="subHeadingLine">
  Achieved mastery in web development services, on both theoretical and practical levels.
</p>
  <div className="softwareGrid">
    <div className="softwareCard">
      <h2>Architecture</h2>
      <p>
        Carefully think through the structure to ensure the web app is scalable and every module can be effortlessly changed and redeployed. Changing the tech stack won’t be a headache as well.
      </p>
      <span>
        Team development/ Smart deployment/‍Organized refactoring/
      </span>
    </div>
    <div className="softwareCard">
      <h2>Frameworks</h2>
      <p>
        When choosing technologies, we rely on these 3 criteria: problem-solving, web app development speed and compatibility with emerging technologies. Options you can see below perfectly meet them all.
      </p>
      <span>
        React.js/ Next.js/ Express.js/Nest.js/ Node.js/
      </span>
    </div>
    <div className="softwareCard">
      <h2>Cloud hosting</h2>
      <p>
        Get the most out of Amazon’s time-proven solutions like AWS EC2 and use other services like DigitalOcean and Azure to host the web app backend.
      </p>
      <span>
        AWS/ DigitalOcean/ Azure/
      </span>
    </div>
    <div className="softwareCard">
      <h2>Scalability</h2>
      <p>
        Deliver solutions with scalability in mind. To provide convenient usage and prevent crashes even if with 10K simultaneous users trying to access the web app.
      </p>
      <span>
        Load balancing/ Partitioning/Vertical scaling/ Horizontal scaling/
      </span>
    </div>
    <div className="softwareCard">
      <h2>Search Engines</h2>
      <p>
      Empower fast and customizable search process with the help of rapidly-evolving open-source search engines like Elasticsearch and Solr.</p>
      <span>
        Elasticsearch/ Solr/
      </span>
    </div>
    <div className="softwareCard">
      <h2>Infrastructure</h2>
      <p>Take full responsibility for installing & managing server infrastructure as well as for headache-free code deployments.</p>
      <span>
        Docker/ Nginx/ AWS Lambda/AWS Elastic Beanstalk/
      </span>
    </div>
    </div>
    </div>
    </div>
);}    
